import {CanBeSignal, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {coreStore} from '@gongxigames/framework/core/globals';
import type {UpdateManager} from '@gongxigames/framework/core';
import {ActionFunction} from './Wrap';

export function Delay(delay: CanBeSignal<number>, updater?: UpdateManager): ActionFunction {
    const result: ActionFunction = (instance, done) => {
        updater ??= coreStore.updateManager.value!;
        const delayVal = getProp(delay);

        updater.addTimer(done, delayVal, true);
    };

    return result;
};
